import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { RolePreview, Section, Theme } from '@/types'

interface UIState {
  activeGroupId: string | null
  section: Section
  theme: Theme
  adminViewEnabled: boolean
  rolePreview: RolePreview
  setActiveGroupId: (id: string | null) => void
  setSection: (section: Section) => void
  setTheme: (theme: Theme) => void
  toggleAdminView: () => void
  setRolePreview: (role: RolePreview) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      activeGroupId: null,
      section: 'wishlist',
      theme: 'midnight',
      adminViewEnabled: true,
      rolePreview: 'actual',
      setActiveGroupId: (id) => set({ activeGroupId: id }),
      setSection: (section) => set({ section }),
      setTheme: (theme) => {
        document.documentElement.dataset.theme = theme
        set({ theme })
      },
      toggleAdminView: () => set((s) => ({ adminViewEnabled: !s.adminViewEnabled })),
      setRolePreview: (role) => set({ rolePreview: role }),
    }),
    {
      name: 'cg-ui',
      onRehydrateStorage: () => (state) => {
        if (state?.theme) {
          document.documentElement.dataset.theme = state.theme
        }
      },
    },
  ),
)
